import { render, staticRenderFns } from "./profile-badge.vue?vue&type=template&id=1353c5c7&"
import script from "./profile-badge.vue?vue&type=script&lang=js&"
export * from "./profile-badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports